export default "__VITE_ASSET__rOzX0pZN__"